import { asyncApiCall } from "../utils/services";

export class ConfigServices {
    apiUrl;

    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }

    getApplicationAppConfig = async () =>
        await asyncApiCall(`${this.apiUrl}/services/getApplicationAppConfig`, { method: "GET" })

    getConfigFile = async () => 
        await asyncApiCall(`${this.apiUrl}/appConfig.json`, { method: "GET" })
    
    getLocaleFile = async (locale) =>
        await asyncApiCall(`${this.apiUrl}/${locale}.json`, { method: "GET" })
}


// WEBPACK FOOTER //
// ./src/services/configServices.ts